import * as actionTypes from "./actionTypes";

const initialState = {
    values: {},
    table: {
        data: [],
        sort: {
            property: undefined,
            direction: undefined
        },
        pageNumber: undefined,
        totalPages: undefined,
        totalElements: undefined,
    },
    visitorsList: [],
    //form specific:
    visitorsData: {},

    loading: false,
    loadingEditRequest: false,

    checkOut: false,
    visitorWasEdited: false,

    error: undefined,
};

const visitsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.VISITOR_SEARCH_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.VISITOR_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                table: {
                    ...state.table,
                    data: payload.content,
                    totalPages: payload.totalPages,
                    totalElements: payload.totalElements,
                    sort: {
                        direction: payload.sort[0].direction,
                        property: payload.sort[0].property,
                    },
                    pageSize: payload.pageable.pageSize,
                    pageNumber: payload.pageable.pageNumber
                }
            };
        case actionTypes.VISITOR_SEARCH_FAILED:
            return {
                ...state,
                loading: false,
            };
        case actionTypes.GET_VISITOR_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.GET_VISITOR_SUCCESS:
            return {
                ...state,
                loading: false,
                visitorData: payload,
            };
        case actionTypes.GET_VISITOR_FAILED:
            return {
                ...state,
                loading: false,
            };
        case actionTypes.EDIT_VISITOR_REQUEST:
            return {
                ...state,
                loadingEditRequest: true
            };
        case actionTypes.EDIT_VISITOR_SUCCESS:
            return {
                ...state,
                loadingEditRequest: false,
                visitorWasEdited: true
            };
        case actionTypes.EDIT_VISITOR_FAILED:
            return {
                ...state,
                loadingEditRequest: false,
                visitorWasEdited: false
            };
        case actionTypes.RESET_VISITOR_FORM:
            return {
                ...state,
                visitorsData: {},
                loadingEditRequest: false,
                visitorWasEdited: false,
                error: undefined
            };
        default:
            return state;
    }
};

export default visitsReducer;